export default {
  BILLING_DETAILS: `Billing`,
  BILLINGDETAILS: {
    LABEL: `Facturation`,
    DESCRIPTION: ``
  },
  BILLINGID: {
    LABEL: `Billing identifier`,
    PLACEHOLDER: `Enter an identifier`,
    DESCRIPTION: `This can be purchase order number, a contract number or any other identifier.`
  },
  NONBILLABLE: {
    LABEL: `Non-billable`,
    DESCRIPTION: ``
  },
  MEMO1: {
    LABEL: `Memo 1`,
    PLACEHOLDER: `Enter a note 30 characters or shorter`,
    DESCRIPTION: ``
  },
  MEMO2: {
    LABEL: `Memo 2`,
    PLACEHOLDER: `Enter a note 30 characters or shorter`,
    DESCRIPTION: ``
  },
  MEMO3: {
    LABEL: `Memo 3`,
    PLACEHOLDER: `Enter a note 30 characters or shorter`,
    DESCRIPTION: ``
  }
}
